<template>
<div class="d-flex fullHeight">
    <HelppageSideMenu @set="initialize" class="d-sm-block d-none"/>
    <div class="mainContent mainwindow">
        <div class="p-2">
            <div class="pageTitles">よくある質問</div>
            <div class="cardwindow mt-3 mb-4">
                <div class="accentHelp">
                    <h5 class="font-weight-bold mb-4">予約に関して</h5>
                    <HelpMenuItem menuTitle="Q．予約を確認したいです。" menuId="6">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当のプランタイプをクリックします。</p>
                        <p>5. 該当の予約のプレー日をクリックします。</p>
                        <p>6. 予約状況照会画面が表示されたら終了です。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．予約に対する問合せをしたいです。" menuId="7">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>※サイドメニューにあるお問合せはゴルフ場に対するお問合せ（要望等）になりますのでご注意ください。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の「問合せ」ボタンをクリックします。</p>
                        <p>6. 予約のお問合せ画面が表示されます。</p>
                        <p>7. 画面下の入力欄にメッセージを入力し、「登録」ボタンをクリックします。</p>
                        <p>8. メッセージ欄にメッセージが表示されたら終了です。</p>
                        <p>※プレー日を経過した予約ではメッセージの送信ができません。サイドメニューにあるお問合せより、メッセージを送信ください。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．予約をキャンセルしたいです。" menuId="8">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の「削除」ボタンをクリックします。</p>
                        <p>6. 「この予約をキャンセルします。」という確認ダイアログが表示されますので、「はい」をクリックします。</p>
                        <p>7. キャンセルされますと、該当の予約の「削除」ボタンがクリックできない（灰色）状態に変化します。</p>
                        <p>※プレー日を経過した予約ではキャンセル操作できません。</p>
                    </HelpMenuItem>
                    <!-- クラシック用にコメントアウト -->
                    <!-- <HelpMenuItem menuTitle="Q．予約プランを変更したいです。" menuId="13">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当の予約のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の変更ボタンをクリックします。</p>
                        <p>※プレー日を経過した予約では変更できません。</p>
                        <p>6. 予約変更画面が表示されます。</p>
                        <p>7. プラン名横に表示されている変更ボタンをクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_plan_1.jpg" alt="プラン変更1" />
                        <p>8. 検索欄に任意の入力をし、「検索する」ボタンをクリックします。</p>
                        <p>9. プランを選択します。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_plan_2.jpg" alt="プラン変更2" />
                        <p>10. スタート時間を選択し、「次へ」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_plan_3.jpg" alt="プラン変更3" />
                        <p>11. 「連絡先電話番号」を入力し、「予約を確定」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_plan_4.jpg" alt="プラン変更4" />
                        <p>12. 同伴者情報を入力し、「確定」をクリックしたら終了です。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_plan_5.jpg" alt="プラン変更5" />
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．予約日を変更したいです。" menuId="14">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当の予約のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の変更ボタンをクリックします。</p>
                        <p>※プレー日を経過した予約では変更できません。</p>
                        <p>6. 予約変更画面が表示されます。</p>
                        <p>7. プレー日に表示されている変更ボタンをクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_date_1.jpg" alt="プレー日変更1" />
                        <p>8. 検索欄に任意の入力をし、「検索する」ボタンをクリックします。</p>
                        <p>9. プランを選択します。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_date_2.jpg" alt="プレー日変更2" />
                        <p>10. スタート時間を選択し、「次へ」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_date_3.jpg" alt="プレー日変更3" />
                        <p>11. 「連絡先電話番号」を入力し、「予約を確定」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_date_4.jpg" alt="プレー日変更4" />
                        <p>12. 同伴者情報を入力し、「確定」をクリックしたら終了です。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_date_5.jpg" alt="プレー日変更5" />
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．スタート時間を変更したいです。" menuId="15">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当の予約のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の変更ボタンをクリックします。</p>
                        <p>※プレー日を経過した予約では変更できません。</p>
                        <p>6. 予約変更画面が表示されます。</p>
                        <p>7. スタート時間横に表示されている変更ボタンをクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_start_time_1.jpg" alt="スタート時間変更1" />
                        <p>8. スタート時間を選択し、「次へ」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_start_time_3.jpg" alt="スタート時間変更3" />
                        <p>9. 「連絡先電話番号」を入力し、「予約を確定」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_start_time_4.jpg" alt="スタート時間変更4" />
                        <p>10. 同伴者情報を入力し、「確定」をクリックしたら終了です。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_date_5.jpg" alt="プレー日変更5" />
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．人数を変更したいです。" menuId="16">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当の予約のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の変更ボタンをクリックします。</p>
                        <p>※プレー日を経過した予約では変更できません。</p>
                        <p>6. 予約変更画面が表示されます。</p>
                        <p>7. 人数横に表示されている変更ボタンをクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_number_1.jpg" alt="人数変更1" />
                        <p>8. 同伴者情報を入力し、「確定」をクリックしたら終了です。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_play_number_2.jpg" alt="人数変更2" />
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．組数を追加したいです。" menuId="17">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当の予約のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の変更ボタンをクリックします。</p>
                        <p>※プレー日を経過した予約では変更できません。</p>
                        <p>6. 予約変更画面が表示されます。</p>
                        <p>7. 組数横に表示されている変更ボタンをクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_1.jpg" alt="人数変更1" />
                        <p>8. 「組を追加」をクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_2.jpg" alt="人数変更2" />
                        <p>9. スタート時間を選択します。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_3.jpg" alt="人数変更3" />
                        <p>10. 同伴者情報を入力し、「確定」をクリックしたら終了です。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_4.jpg" alt="人数変更4" />
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．組数を減らしたいです。" menuId="18">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「予約状況一覧」をクリックします。</p>
                        <p>4. 一覧左上のタブから該当の予約のプランタイプをクリックします。</p>
                        <p>5. 該当の予約の変更ボタンをクリックします。</p>
                        <p>※プレー日を経過した予約では変更できません。</p>
                        <p>6. 予約変更画面が表示されます。</p>
                        <p>7. 組数横に表示されている変更ボタンをクリックします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_1.jpg" alt="人数変更1" />
                        <p>8. 削除したい組の「組を削除」にチェックをします。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_5.jpg" alt="人数変更2" />
                        <p>9. 「確定」をクリックしたら終了です。</p>
                        <img class="reserve-img" src="/images/help/reserve_change_group_4.jpg" alt="人数変更4" />
                    </HelpMenuItem> -->
                </div>
            </div>
        </div>
            <HelppageSideMenu @set="initialize" class="d-sm-none"/>
    </div>
</div>
</template>


<script>
import HelpMenuItem from './components/HelpMenuItem';
import HelppageSideMenu from './HelppageSideMenu';

export default {
components: {
        HelppageSideMenu,
        HelpMenuItem
    },
    data(){
        return {
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        SigninForm() {
            this.$router.push("/");
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
        }
    }
}
</script>
